<template>
    <div class="container mt-4">

        
        <!-- Tabs en Escritorio  col-3 da 4 columnas por fila) -->
        <div class="d-none d-md-block">
            <div class="row">
                <div v-for="(tab, index) in tabs" :key="index" class="col-3 mb-3">
                    <button :class="['btn btn-outline-primary w-100', activeTab === index ? 'active' : '']"
                        @click="changeTab(index)">
                        {{ tab.name }}
                    </button>
                </div>
            </div>
        </div>

        <!-- Tabs en Móviles (Swiper) -->
        <div class="d-block d-md-none">
            <Swiper ref="swiperRef" :slides-per-view="isMobile ? 2.5 : 4" :space-between="10" class="mb-3"
                :breakpoints="breakpoints">
                <SwiperSlide v-for="(tab, index) in tabs" :key="index">
                    <button :class="['btn btn-outline-primary w-100', activeTab === index ? 'active' : '']"
                        @click="changeTab(index)">
                        {{ tab.name }}
                    </button>
                </SwiperSlide>
            </Swiper>
        </div>



        <!-- Contenido de los Tabs -->
        <div v-for="(tab, index) in tabs" :key="index" v-show="activeTab === index">
            <div class="card mt-3">
                <div class="card-body">
                    <h5 class="card-title text-center" style="color: #0078be;">{{ tab.title }}</h5>

                    <form>
                        <div class="row">
                            <div v-for="field in tab.fields" :key="field.id" class="col-md-6 mb-3">
                                <label :for="field.id" class="form-label">{{ field.label }}</label>
                                <input v-model="formData[field.id]" type="text" class="form-control" :id="field.id"
                                    :placeholder="field.placeholder" />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <!-- Botón para obtener datos -->

        <div class="d-flex justify-content-end mt-4">
                <button @click="getData" style="background: #0078be!important;" type="submit" class="btn btn-success btn-sm me-2">
                    Registrar
                </button>
            </div>

    </div>
</template>

<script>
/* eslint-disable */
import { Swiper, SwiperSlide } from "swiper/vue";
import { ref, onMounted, onBeforeUnmount } from "vue";
import "swiper/css";

export default {
    name: "Examenes",
    components: { Swiper, SwiperSlide },
    setup() {
        const swiperRef = ref(null);
        const activeTab = ref(0);
        const isMobile = ref(window.innerWidth < 768);
        const breakpoints = ref({
            768: { slidesPerView: 4, spaceBetween: 10 },
        });

        const tabs = ref([
            {
                name: "Bioquímica", title: "Bioquímica Sanguínea", fields: [
                    { id: "glucosa", label: "Glucosa", placeholder: "70-100 mg/dl" },
                    { id: "urea", label: "Urea", placeholder: "10-50 mg/dl" },
                    { id: "creatinina", label: "Creatinina", placeholder: "0.7-1.2 mg/dl" },
                    { id: "acido-urico", label: "Ácido Úrico", placeholder: "2.4-7.0 mg/dl" },
                ]
            },
            {
                name: "Enzimas", title: "Enzimas", fields: [
                    { id: "tgo", label: "T.G.O.", placeholder: "Hasta 37.0" },
                    { id: "tgp", label: "T.G.P.", placeholder: "Hasta 42.0" },
                    { id: "amilasa", label: "Amilasa", placeholder: "Hasta 100.0" },
                    { id: "ldh", label: "LDH", placeholder: "Hasta 250.0" },
                ]
            },
            {
                name: "Electrolitos", title: "Electrolitos", fields: [
                    { id: "sodio", label: "Sodio", placeholder: "135-145 mmol/L" },
                    { id: "potasio", label: "Potasio", placeholder: "3.5-5.1 mmol/L" },
                    { id: "calcio", label: "Calcio", placeholder: "8.5-10.2 mg/dl" },
                    { id: "cloro", label: "Cloro", placeholder: "95-105 mmol/L" },
                ]
            },
            {
                name: "Otros", title: "Otros Exámenes", fields: [
                    { id: "albumina", label: "Albúmina", placeholder: "3.5-5.5 g/dl" },
                    { id: "globulina", label: "Globulina", placeholder: "2.0-3.5 g/dl" },
                ]
            },
            {
                name: "Otros2", title: "Otros Exámenes2", fields: [
                    { id: "albumina", label: "Albúmina", placeholder: "3.5-5.5 g/dl" },
                    { id: "globulina", label: "Globulina", placeholder: "2.0-3.5 g/dl" },
                ]
            }
        ]);

        const formData = ref({});

        // Inicializar formData con claves vacías
        tabs.value.forEach(tab => {
            tab.fields.forEach(field => {
                formData.value[field.id] = "";
            });
        });

        const changeTab = (index) => {
            activeTab.value = index;

            // Mover Swiper al tab seleccionado (solo en móviles)
            if (swiperRef.value?.swiper && isMobile.value) {
                swiperRef.value.swiper.slideTo(index);
            }
        };

        const getData = () => {
            console.log("Datos del formulario:", JSON.stringify(formData.value, null, 2));
        };

        const handleResize = () => {
            isMobile.value = window.innerWidth < 768;
        };

        onMounted(() => {
            window.addEventListener("resize", handleResize);
        });

        onBeforeUnmount(() => {
            window.removeEventListener("resize", handleResize);
        });

        return {
            swiperRef,
            activeTab,
            isMobile,
            breakpoints,
            tabs,
            formData,
            changeTab,
            getData,
        };
    },

    mounted() {
        if (this.isMobile) {
            this.$eventBus.emit("activeShowMenu");
        }
    },
};
</script>

<style scoped>
button.active {
    background-color: #0078be!important;
    color: white!important;
}
</style>